import TurnoverStatisticsTable from './Table';

export default TurnoverStatisticsTable;
